module.exports = __webpack_public_path__ + "img/appointment.f514a0ac.svg";